import { Pipe, PipeTransform } from '@angular/core';
import {TenantService} from "../../../services/tenant.service";
import {environment} from "../../../../environments/environment";

@Pipe({
  name: 'sharedLink'
})
export class SharedLinkPipe implements PipeTransform {

  constructor(public tenant: TenantService) {
  }

  transform(value: unknown, ...args: unknown[]): string {
    return environment.donation_url + '/t/' + this.tenant.currentTenantValue + '/sq/' + value;
  }

}
